import React from 'react';
import { usePlayerStore } from '../../../../stores/StoreContext';
import AnnotationMarkersPlayback from './AnnotationMarkersPlayback';
import AnnotationMarkersLive from './AnnotationMarkersLive';
const AnnotationMarkers = () => {
  const isLive = usePlayerStore((state) => state.isLive);
  return (
    <>{isLive ? <AnnotationMarkersLive /> : <AnnotationMarkersPlayback />}</>
  );
};

export default AnnotationMarkers;
